"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpClient = exports.BLOCKPASS_SERVICE = void 0;
const axios_1 = __importDefault(require("axios"));
var BLOCKPASS_SERVICE;
(function (BLOCKPASS_SERVICE) {
    BLOCKPASS_SERVICE["ma"] = "bp_ma";
    BLOCKPASS_SERVICE["wid"] = "bp_wid";
    BLOCKPASS_SERVICE["ac"] = "bp_ac";
    BLOCKPASS_SERVICE["kycc"] = "bp_kycc";
    BLOCKPASS_SERVICE["auth"] = "bp_auth";
    BLOCKPASS_SERVICE["myacct"] = "bp_myacct";
    BLOCKPASS_SERVICE["vp"] = "bp_vp";
    BLOCKPASS_SERVICE["cms"] = "bp_cms";
    BLOCKPASS_SERVICE["kyb"] = "bp_kyb";
    BLOCKPASS_SERVICE["kybform"] = "bp_kybform";
    BLOCKPASS_SERVICE["kybc"] = "bp_kybc";
})(BLOCKPASS_SERVICE = exports.BLOCKPASS_SERVICE || (exports.BLOCKPASS_SERVICE = {}));
const INDIVIDUAL_SERVICE = [
    BLOCKPASS_SERVICE.ma,
    BLOCKPASS_SERVICE.wid,
    BLOCKPASS_SERVICE.myacct,
    BLOCKPASS_SERVICE.kybform
];
const BUSINESS_SERVICE = [
    BLOCKPASS_SERVICE.auth,
    BLOCKPASS_SERVICE.ac,
    BLOCKPASS_SERVICE.kycc,
    BLOCKPASS_SERVICE.kybc
];
const KYB_BUSINESS_SERVICE = [BLOCKPASS_SERVICE.kyb];
const OPERATOR_SERVICE = [BLOCKPASS_SERVICE.vp];
const MARKETER_SERVICE = [BLOCKPASS_SERVICE.cms];
class HttpClient {
    constructor(bpService, clientOS = 'unknow', clientVersion = 'unknow') {
        let accType = 'unknow';
        if (INDIVIDUAL_SERVICE.includes(bpService)) {
            accType = 'individual';
        }
        else if (BUSINESS_SERVICE.includes(bpService)) {
            accType = 'business';
        }
        else if (OPERATOR_SERVICE.includes(bpService)) {
            accType = 'bpOperator';
        }
        else if (MARKETER_SERVICE.includes(bpService)) {
            accType = 'bpMarketer';
        }
        else if (KYB_BUSINESS_SERVICE.includes(bpService)) {
            accType = 'kybBusiness';
        }
        this.client = axios_1.default.create({
            headers: {
                'x-client-os': clientOS,
                'x-client-version': clientVersion,
                'x-blockpass-service': bpService,
                'x-blockpass-acctype': accType,
            },
        });
    }
    getIns() {
        return this.client;
    }
    setBaseUrl(baseURL) {
        this.client.defaults.baseURL = baseURL;
    }
    setAuthSession(session, hasBearer = false) {
        if (hasBearer) {
            this.client.defaults.headers['authorization'] = `Bearer ${session}`;
        }
        else {
            this.client.defaults.headers['authorization'] = session;
        }
    }
    async get(url, config = {}) {
        return this.client.get(url, config);
    }
    async post(url, data, config = {}) {
        return this.client.post(url, data, config);
    }
    async put(url, data, config = {}) {
        return this.client.put(url, data, config);
    }
    async delete(url, config = {}) {
        return this.client.delete(url, config);
    }
    async request(config) {
        return this.client.request(config);
    }
}
exports.HttpClient = HttpClient;
